import React from 'react';
import { Search, Crown, Medal, Star, Award } from 'lucide-react';
import CustomSelect from '../shared/CustomSelect';

const ClientFilters = ({
                           searchTerm,
                           onSearchChange,
                           clientTypeFilter,
                           onClientTypeChange,
                           statusFilter,
                           onStatusChange,
                           consentFilter,
                           onConsentChange,
                           tierFilter,
                           onTierChange,
                           approvalFilter,
                           onApprovalChange
                       }) => {
    // Options for Client Type filter
    const clientTypeOptions = [
        { value: 'ALL', label: 'All Types' },
        { value: 'RETAIL', label: 'Retail Clients' },
        { value: 'CORPORATE', label: 'Corporate Clients' }
    ];

    // Options for Status filter
    const statusOptions = [
        { value: 'ALL', label: 'All Status' },
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' }
    ];

    // Options for Consent filter
    const consentOptions = [
        { value: 'ALL', label: 'All Consent Status' },
        { value: 'GIVEN', label: 'Consent Given' },
        { value: 'NOT_GIVEN', label: 'No Consent' }
    ];

    // Options for Approval Status filter
    const approvalOptions = [
        { value: 'ALL', label: 'All Approval Status' },
        { value: 'PENDING', label: 'Pending' },
        { value: 'APPROVED', label: 'Approved' },
        { value: 'REJECTED', label: 'Rejected' }
    ];

    // Options for Loyalty Tier filter
    const tierOptions = [
        { value: 'ALL', label: 'All Tiers' },
        { value: 'PLATINUM', label: '👑 Platinum (5+)' },
        { value: 'GOLD', label: '🏅 Gold (3-4)' },
        { value: 'SILVER', label: '⭐ Silver (2)' },
        { value: 'BRONZE', label: '🏆 Bronze (1)' },
        { value: 'NO_TIER', label: 'No Tier (0)' }
    ];

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
                {/* Search */}
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
                    <input
                        type="text"
                        placeholder="Search clients..."
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                {/* Client Type Filter */}
                <CustomSelect
                    value={clientTypeFilter}
                    onChange={onClientTypeChange}
                    options={clientTypeOptions}
                    placeholder="Select client type"
                />

                {/* Loyalty Tier Filter */}
                <CustomSelect
                    value={tierFilter}
                    onChange={onTierChange}
                    options={tierOptions}
                    placeholder="Select loyalty tier"
                />

                {/* Status Filter */}
                <CustomSelect
                    value={statusFilter}
                    onChange={onStatusChange}
                    options={statusOptions}
                    placeholder="Select status"
                />

                {/* Cross-sell Consent Filter */}
                <CustomSelect
                    value={consentFilter}
                    onChange={onConsentChange}
                    options={consentOptions}
                    placeholder="Select consent status"
                />

                {/* Approval Status Filter */}
                <CustomSelect
                    value={approvalFilter}
                    onChange={onApprovalChange}
                    options={approvalOptions}
                    placeholder="Select approval status"
                />
            </div>

            {/* Active Tier Filter Badge */}
            {tierFilter && tierFilter !== 'ALL' && (
                <div className="mt-3 flex items-center gap-2">
                    <span className="text-sm text-gray-600">Filtering by:</span>
                    <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gradient-to-r ${
                        tierFilter === 'PLATINUM' ? 'from-purple-100 to-purple-50 border border-purple-200' :
                            tierFilter === 'GOLD' ? 'from-yellow-100 to-yellow-50 border border-yellow-200' :
                                tierFilter === 'SILVER' ? 'from-gray-100 to-gray-50 border border-gray-200' :
                                    tierFilter === 'BRONZE' ? 'from-orange-100 to-orange-50 border border-orange-200' :
                                        'from-gray-50 to-gray-50 border border-gray-200'
                    }`}>
                        {tierFilter === 'PLATINUM' && <Crown className="w-4 h-4 text-purple-600" />}
                        {tierFilter === 'GOLD' && <Medal className="w-4 h-4 text-yellow-600" />}
                        {tierFilter === 'SILVER' && <Star className="w-4 h-4 text-gray-600" />}
                        {tierFilter === 'BRONZE' && <Award className="w-4 h-4 text-orange-600" />}
                        <span className={`text-sm font-medium ${
                            tierFilter === 'PLATINUM' ? 'text-purple-800' :
                                tierFilter === 'GOLD' ? 'text-yellow-800' :
                                    tierFilter === 'SILVER' ? 'text-gray-800' :
                                        tierFilter === 'BRONZE' ? 'text-orange-800' :
                                            'text-gray-600'
                        }`}>
                            {tierOptions.find(t => t.value === tierFilter)?.label || tierFilter}
                        </span>
                    </div>
                    <button
                        onClick={() => onTierChange('ALL')}
                        className="text-sm text-gray-500 hover:text-gray-700 underline"
                    >
                        Clear
                    </button>
                </div>
            )}
        </div>
    );
};

export default ClientFilters;
